/**
 * useDataBins
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import DataBinsContext from './data-bins-context'

const useDataBins = () => {
  const context = useContext(DataBinsContext)
  return context
}

export default useDataBins
